<div class="logo" *ngIf="Redesign">
  <img src="assets/general/logo.png" />
  <p>بنتو</p>
</div>
<div
  [ngClass]="{ 'title-old': !Redesign, title: Redesign }"
  *ngIf="type === 'current'"
>
  وزن خود را مشخص کنید
</div>
<div
  [ngClass]="{ 'title-old': !Redesign, title: Redesign }"
  *ngIf="type === 'start'"
>
  وزن فعلی خود را مشخص کنید
</div>

<div>
  <div class="picker-wrapper">
    <div
      id="weight_holder"
      (swipeup)="swipe($event.type, 'weight', $event)"
      (swipedown)="swipe($event.type, 'weight', $event)"
    ></div>
    <div
      id="decimal_holder"
      (swipeup)="swipe($event.type, 'decimal', $event)"
      (swipedown)="swipe($event.type, 'decimal', $event)"
    ></div>
    <div
      class="line"
      [ngClass]="{ 'line-up-old': !Redesign, 'line-up': Redesign }"
    ></div>
    <div
      class="line"
      [ngClass]="{ 'line-down-old': !Redesign, 'line-down': Redesign }"
    ></div>

    <p id="unit">کیلوگرم</p>
    <span id="dot"></span>
    <div id="weight">
      <div class="picker-item" *ngFor="let weight of weights">
        {{ weight }}
      </div>
    </div>
    <div id="decimal">
      <div class="picker-item" *ngFor="let decimal of decimals">
        {{ decimal }}
      </div>
    </div>
    <!-- </div>
<div class="container">
  <div
    [ngClass]="decimalWeight ? 'holder border-active' : 'holder border-disable'"
    style="right: 60px"
  >
    <input
      *ngIf="!isDetail"
      type="tel"
      [(ngModel)]="decimalWeight"
      maxlength="3"
      (input)="checkActivatingButton(0)"
      (focus)="decimalWeight = ''"
      attr.id="input{{ 0 }}"
      placeholder="94"
    />
    <input
      *ngIf="isDetail"
      type="tel"
      [(ngModel)]="decimalWeight"
      maxlength="3"
      (input)="checkActivatingButton(0)"
      (focus)="decimalWeight = ''"
      attr.id="inputDetail{{ 0 }}"
      placeholder="94"
    />
  </div>
  <div class="dot">.</div>
  <div
    [ngClass]="
      fractionalWeight ? 'holder border-active' : 'holder border-disable'
    "
    style="right: 0px"
  >
    <input
      *ngIf="!isDetail"
      type="tel"
      [(ngModel)]="fractionalWeight"
      maxlength="1"
      (input)="checkActivatingButton(1)"
      (focus)="fractionalWeight = ''"
      (keyup)="keytab($event, 1)"
      attr.id="input{{ 1 }}"
    />
    <input
      *ngIf="isDetail"
      type="tel"
      [(ngModel)]="fractionalWeight"
      maxlength="1"
      (input)="checkActivatingButton(1)"
      (focus)="fractionalWeight = ''"
      (keyup)="keytab($event, 1)"
      attr.id="inputDetail{{ 1 }}"
    />
  </div>
</div>
<div *ngIf="hasError" class="error-title">وزن وارد شده اشتباه است</div>
<div class="input-title">کیلوگرم</div> -->
  </div>
</div>
